import gql from 'graphql-tag';

export const GET_IN_APP_NOTIFICATIONS = gql`
  query getInAppNotifications($listInfo: ListInfoInput!) {
    getInAppNotifications(listInfo: $listInfo) {
      notifications {
        notificationId
        event
        time
        user {
          userId
          name
          email
        }
        emailAddress
        state
        approval {
          additionalMessage
        }
        vendorConversation {
          type
          subject
          user {
            userId
            firstName
            lastName
            email
          }
          conversationId
          parentConversationId
        }
        kbArticleFeedback {
          feedbackId
          feedback
          status
          feedbackBy {
            userId
            name
          }
          createdOn
          resolvedBy {
            userId
            name
          }
          resolvedOn
          kbArticle {
            name
            itemId
          }
        }
        workItem {
          workId
          module
          subject
          displayId
          client {
            accountId
            name
          }
          site {
            id
            name
          }
          ticket {
            ticketId
            techGroup {
              groupId
              name
            }
            priority
            source
            ticketType
          }
        }
        alert {
          id
          asset {
            assetId
            name
            client {
              name
            }
            site {
              name
            }
            assetClass {
              name
              classId
            }
          }
          message
          description
          severity
        }
        clientConversation {
          type
          subject
          user {
            userId
            firstName
            lastName
            email
          }
          conversationId
          parentConversationId
          client {
            accountId
            name
          }
        }
        task {
          taskId
          displayId
          title
          description
          status
          estimatedTime
          scheduledStartDate
          dueDate
          overdue
          actualStartDate
          actualEndDate
          priority
          technician {
            userId
            firstName
            lastName
            email
          }
          techGroup {
            groupId
            name
          }
          module
          createdTime
          workItem {
            workId
            module
            subject
            displayId
            client {
              accountId
              name
            }
            site {
              id
              name
            }
            ticket {
              ticketId
              techGroup {
                groupId
                name
              }
              priority
              source
              ticketType
            }
          }
        }
      }
      listInfo {
        totalCount
        page
        pageSize
        hasMore
      }
    }
  }
`;

export const GET_NEW_IN_APP_NOTIFICATIONS_COUNT = gql`
  query {
    getNewInAppNotificationsCount
  }
`;
